<template>
  <div class="mit-home-page mit-page">
      <!-- TODO
      Add my next Reservation(s) widget
      Add Busiest Reservation Times widget  -->
      <v-container fluid>
          <!-- <BaseMitLoading :show="loadingSpaces || loadingAllSpaces || loadingSave" :overlayFullscreen="false"/> -->
              <v-card class="mit-info-card" style="width:100%">
                  <v-card-title color="white">HR Dashboard</v-card-title>
                  <v-card-subtitle class="caption">Information for HR</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text class="grey lighten-5">
                      <v-row>
                          <v-col col="12" md="6">
                              <v-card class="" elevation="4">
                                  <v-card-title><v-icon class="pr-1" color="red lighten-1">mdi-account-new</v-icon>Incoming People</v-card-title>
                                  <v-card-text>
                                      <BaseMitChartBasic charType="bar" title="" labelY="Number of People" labelX="" :dataSets="chartIncomingPeople" legend="top"/>
                                  </v-card-text>
                              </v-card>
                          </v-col>
                          <v-col col="12" md="6">
                              <v-card class="" elevation="4">
                                  <v-card-title><v-icon class="pr-1" color="red lighten-1">mdi-account-new</v-icon>Recently Activated/Deactived People</v-card-title>
                                  <v-card-text>
                                    <BaseMitChartBasic chartId="chartActive" chartType="line" :borderWidth="2" title="" labelY="Number of People" labelX="" :dataSets="chartActivePeople" legend="top"/>
                                  </v-card-text>
                              </v-card>
                          </v-col>
                          <v-col col="12" md="6">
                              <v-card class="" elevation="4">
                                  <v-card-title><v-icon class="pr-1" color="red lighten-1">mdi-account-new</v-icon>Total People</v-card-title>
                                  <v-card-text>
                                    <BaseMitChartBasic chartId="chartTotal" chartType="pie" :borderWidth="1" title="" labelY="" labelX="" :dataSets="chartTotalPeople" legend="top"/>
                                  </v-card-text>
                              </v-card>
                          </v-col>
                          <!-- <v-col col="12" md="6">
                              <v-card class="" elevation="4">
                                  <v-card-title><v-icon class="pr-1">mdi-account-deleted</v-icon>Recently Inactive People</v-card-title>
                                  <v-card-text>
                                      
                                      <v-simple-table fixed-header height="300px">
                                        <template v-slot:default>
                                          <thead>
                                            <tr>
                                                <th class="text-left">Name</th>
                                                <th class="text-left">Role</th>
                                                <th class="text-left">CSAIL ID</th>
                                                <th class="text-left">Space</th>
                                                <th class="text-left"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td><v-btn class="" small text outlined color="primary" elevation="0" @click="reserveSpace(space)">Edit</v-btn></td>
                                            </tr>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                  </v-card-text>
                              </v-card>
                          </v-col> -->
                      </v-row>
                  </v-card-text>
              </v-card>
      </v-container>
  </div>
</template>

<script>
import moment from 'moment';
import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';

import MitSpacesApiService from '../../../base/services/BaseMitReserveSpacesService.js';
import BaseMitConfigService from '../../../base/services/BaseMitConfigService.js';
import MitReservationService from '../../../base/services/BaseMitReserveService.js';

import BaseMitChartBasic from '../../components/charts/BaseMitChartBasic.vue';

import MitPeopleService from '../../services/MitPeopleService.js';


export default {
  name: 'MitHRDashboardPage',
  components: {
      BaseMitLoading,
      BaseMitDataTable,
      BaseMitChartBasic
  },
  props: {
    userModel: Object, //comes from route
    userRoles: Object //comes from route
  },
  data: function() {
    return {
        chartIncomingPeople: {
                labels:['January','February','March','April','May','June','July'],
                sets:[
                    {
                        label: 'In Progress',
                        data: [2, 10, 30, 0, 45, 0, 0],
                        // backgroundColor: 'rgba(198, 40, 40, .7)',
                        // borderColor: 'rgba(198, 40, 40, 1)'
                        // backgroundColor: 'rgba(192, 202, 51, .7)',
                        // borderColor: 'rgba(192, 202, 51, 1)'
                        backgroundColor: 'rgba(212, 225, 87, .7)',
                        borderColor: 'rgba(212, 225, 87, 1)'
                        
                    },
                    {
                        label: 'Upcoming Appointment',
                        data: [8, 33, 96, 5, 0, 60, 20],
                        // backgroundColor: 'rgba(69, 39, 160, .7)',
                        // borderColor: 'rgba(69, 39, 160, 1)'
                        backgroundColor: 'rgba(124, 179, 66, .7)',
                        borderColor: 'rgba(124, 179, 66, 1)'
                    }
                ]
        },
        chartActivePeople: {
                labels:['January','February','March','April','May','June','July'],
                sets:[
                    {
                        label: 'Actived',
                        fill: false,
                        data: [200, 80, 0, 334, 34, 59, 45],
                        // backgroundColor: 'rgba(21, 101, 192, .5)',
                        // borderColor: 'rgba(21, 101, 192, .6)'
                        backgroundColor: 'rgba(3, 155, 229, .5)',
                        borderColor: 'rgba(3, 155, 229, .6)'
                        

                    },
                    {
                        label: 'Deactived',
                        fill: false,
                        data: [169, 30, 10, 230, 0, 94, 20],
                        // backgroundColor: 'rgba(69, 90, 100, .5)',
                        // borderColor: 'rgba(69, 90, 100, .5)'
                        backgroundColor: 'rgba(0, 151, 167, .7)',
                        borderColor: 'rgba(0, 151, 167, 1)'
                    }
                ]
            },
        chartTotalPeople: {
                labels:['PIs','AA','Grad. Students','UROP', 'Scientists'],
                sets:[
                    {
                        //label: 'Active',
                        //fill: false,
                        data: [89, 34, 120, 45, 75],
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.4)',
                            'rgba(54, 162, 235, 0.4)',
                            'rgba(255, 206, 86, 0.4)',
                            'rgba(75, 192, 192, 0.4)',
                            'rgba(153, 102, 255, 0.4)'
                        ]

                    }
                ]
            }
    }
  },
  mounted() {
      this.spacesUrl = BaseMitConfigService.get('CLIENT_API_SPACES');

  },
  methods:{
      favoriteChanged(space){
      
      }
  }

}
</script>

<style lang="scss" scoped>
.mit-info-card {
  width:100%;
  height:100%;
}
</style>
